import { useState, useEffect } from 'react';

export function isIE(userAgent: string | undefined): boolean {
    return !!userAgent ? /Trident\/|MSIE/.test(userAgent) : false;
}

function useIsIE11() {
    const [isIE11, setIsIE11] = useState(false);

    useEffect(() => {
        setIsIE11(isIE(window.navigator.userAgent));
    }, []);

    return isIE11;
}

export default useIsIE11;
